import { HexPlayer, HexPlayerModes } from "../../../Comps/HexPlayer/HexPlayer";
import { OutlineBox } from "../../../Comps/OutlineBox/OutlineBox";
import { Music } from "../../../Util/Music/Music";

export function HexPlayerChapter(){
    return(
        <div className={'fret-board-chapter'}>
            <h1>The HexKey Player</h1>
            <OutlineBox>
                <HexPlayer playMode={HexPlayerModes.Chords} tonic={Music.G}/>
            </OutlineBox>
        </div>
    )
}